import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewGraficoConsumoCorral = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'grafico_stock_hacienda',
        name: 'Grafico Stock Hacienda',
        component: ViewGraficoConsumoCorral,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router